export default [
    {
        path: "/cms",
        name: "cms__root__",
        redirect: {
            name: "cms-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "cms",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "cms-index",
                component: () => import("@/views/cms/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/cms/fsf",
        name: "cms-fsf-legacy",
        hidden: true,
        redirect: "/pms/fsf/calendar",
    },
    {
        path: "/cms/fsf/calendar",
        name: "cms-fsf-calendar-legacy",
        hidden: true,
        redirect: "/pms/fsf/calendar",
    },
];
